




























































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TbReport } from "@/http";
import { calendarPanel, NumberKeyboard } from "@/components";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { fmoney } from "@/common/util/money";
import calculate from "@/common/util/calculate";
dayjs.locale("zh-cn");
@Component({
  components: {
    calendarPanel,
    NumberKeyboard,
  },
})
export default class salezl extends Vue {
  public $refs: {};
  @Prop({
      default:''
  })
  start:string;
  @Prop({
      default:''
  })
  end:string;
  curZL = 1;
  fmoney = fmoney;
  /**查询项- */
  searchValue1 = {
    shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
    startDate: dayjs(new Date()).startOf("month").format("YYYY-MM-DD") + " " + "00:00:00",
    endDate: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    sortField: 0,
    sortType: 2,
    skip: 0,
    count: 10,
  };
  searchValue2 = {
    shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
    startDate: dayjs(new Date()).startOf("month").format("YYYY-MM-DD") + " " + "00:00:00",
    endDate: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    sortField: 0,
    sortType: 2,
    skip: 0,
    count: 10,
  };
  searchValue3 = {
    shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
    start: dayjs(new Date()).startOf("month").format("YYYY-MM-DD") + " " + "00:00:00",
    end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    nameJobNumber: "",
    skip: 0,
    count: 10,
  };
  /**时间类型下拉 */
  showStatusPopover = false;
  timeType = 1;
  timeOptions = [
    {
      label: "注册时间",
      value: 1,
    },
    {
      label: "最新消费",
      value: 2,
    },
  ];

  /**时间控件 */
  pickerShow = false;
  startDate = dayjs(new Date()).startOf("month").format("YYYY-MM-DD");
  endDate = dayjs(new Date()).format("YYYY-MM-DD");

  /**列表展示
   * 1:图
   * 2：表格
   */
  showType = 1;

  userInfo: any = {};

  /**列表加载相关 */
  refreshing = false;
  loading = false;
  finished = false;
  list = [];
  list2 = [];
  list3 = [];
  total = 0;
  currentPage = 1;
  totalStock = 0;

  timeActive = null;
  hj_1 = 0;
  hj_2 = "0.00";
  hj_3 = "0.00";
  hj_4 = "0.00";
  hj_5 = 0;
  hj_6 = "0.00";
  hj_7 = "0.00";
  hj_8 = "0.00";
  hj_9 = "0.00";
  hj_10 = "0.00";
  hj_11 = "0.00";

  hj_xjnovip = "0.00";
  hj_xj = "0.00";
  hj_cash = "0.00";
  hj_wechat = "0.00";
  hj_alipay = "0.00";
  hj_vipcard = "0.00";
  hj_offlineWeChat = "0.00";
  hj_offlineAlipay = "0.00";
  hj3_ze = "0.00";
  hj3_sxze = "0.00";
  hj3_czze = "0.00";
  iscz = false;
  tipDatashow = false;

  @Watch("searchValue3.nameJobNumber")
  nameChange(val) {
    if (!this.iscz) {
      this.getList();
    }
  }
  created() {
    if(this.start){
			this.searchValue1.startDate = this.start;
			this.searchValue1.endDate = this.end;
			this.startDate = dayjs(this.start).format("YYYY-MM-DD");
			this.endDate = dayjs(this.end).format("YYYY-MM-DD");
		}
  }

  async mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
  }

  chooseZL(tag) {
    this.curZL = tag;
    this.clearSearch();
    this.iscz = true;
    this.getList();
  }
  clearSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          startDate:
            dayjs(new Date()).startOf("month").format("YYYY-MM-DD") + " " + "00:00:00",
          endDate: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          sortField: 0,
          sortType: 2,
          skip: 0,
          count: 10,
        };
        break;
      case 2:
        this.searchValue2 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          startDate:
            dayjs(new Date()).startOf("month").format("YYYY-MM-DD") + " " + "00:00:00",
          endDate: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          sortField: 0,
          sortType: 2,
          skip: 0,
          count: 10,
        };
        break;
      case 3:
        this.searchValue3 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          start:
            dayjs(new Date()).startOf("month").format("YYYY-MM-DD") + " " + "00:00:00",
          end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          nameJobNumber: "",
          skip: 0,
          count: 10,
        };
        break;
      default:
        break;
    }
    this.timeType = 1;
    this.timeActive = null;
    this.startDate = dayjs(new Date()).startOf("month").format("YYYY-MM-DD");
    this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
  }
  openselDate() {
    this.pickerShow = true;
  }
  /**确定选择时间 */
  onselConfirm(date) {
    const [start, end] = date;
    this.startDate = dayjs(start).format("YYYY-MM-DD");
    this.endDate = dayjs(end).format("YYYY-MM-DD");

    this.pickerShow = false;
    this.timeActive = null;
    this.setTimeSearch();
  }
  closeTime() {
    this.pickerShow = false;
  }

  /**下拉刷新 */
  onRefresh() {
    // 清空列表数据
    this.finished = false;
    // 重新加载数据
    // 将 loading 设置为 true，表示处于加载状态
    this.loading = true;
    let arg =
      this.curZL == 1
        ? "searchValue1"
        : this.curZL == 2
          ? "searchValue2"
          : this.curZL == 3
            ? "searchValue3"
            : "searchValue1";
    this[arg].skip = 0;
    this[arg].count = 10;
    this.currentPage = 1;
    this.loadMore();
  }
  /**触底加载 */
  async loadMore() {
    let arg =
      this.curZL == 1
        ? "searchValue1"
        : this.curZL == 2
          ? "searchValue2"
          : this.curZL == 3
            ? "searchValue3"
            : "searchValue1";
    let arg2 =
      this.curZL == 1
        ? "list"
        : this.curZL == 2
          ? "list2"
          : this.curZL == 3
            ? "list3"
            : "list";
    if (this.refreshing) {
      this[arg2] = [];
      this.refreshing = false;
    }
    let s = this[arg].count;
    switch (this.curZL) {
      // 交易总览
      case 1:
        let resjy = await TbReport.GetTransactionOverview(Object.assign({}, this[arg]));
        let resjy2 = await TbReport.GetTransactionOverviewTotal(
          Object.assign({}, this[arg])
        );
        this.list = this[arg].skip == 0 ? resjy.item2 : this.list.concat(resjy.item2);
        this.total = resjy.item1;
        this.hj_1 = resjy2.orderCount;
        this.hj_2 = fmoney(resjy2.orderAmount, 2);
        this.hj_3 = fmoney(resjy2.returnAmount, 2);
        this.hj_4 = fmoney(resjy2.actualAmount, 2);
        this.hj_5 = resjy2.rechargeCount;
        this.hj_6 = fmoney(resjy2.rechargeAmount, 2);
        this.hj_7 = fmoney(resjy2.giftAmount, 2);
        this.hj_8 = fmoney(resjy2.subtotal, 2);
        this.hj_9 = fmoney(resjy2.exActualAmount, 2);
        this.hj_10 = fmoney(resjy2.exOrderAmount, 2);
        this.hj_11 = fmoney(resjy2.exReturnOrderAmount, 2);
        this.iscz = false;
        break;
      // 支付总览
      case 2:
        let reszf = await TbReport.GetPaymentOverview(Object.assign({}, this[arg]));
        let reszf2 = await TbReport.GetPaymentOverviewTotal(Object.assign({}, this[arg]));
        this.list2 = this[arg].skip == 0 ? reszf.item2 : this.list2.concat(reszf.item2);
        this.total = reszf.item1;
        this.hj_xjnovip = fmoney(reszf2.subtotalNotCard, 2);
        this.hj_xj = fmoney(reszf2.subtotal, 2);
        this.hj_cash = fmoney(reszf2.cashPart, 2);
        this.hj_wechat = fmoney(reszf2.weChatPart, 2);
        this.hj_alipay = fmoney(reszf2.alipayPart, 2);
        this.hj_vipcard = fmoney(reszf2.cardPart, 2);
        this.hj_offlineWeChat = fmoney(reszf2.offlineWeChat, 2);
        this.hj_offlineAlipay = fmoney(reszf2.offlineAlipay, 2);
        this.iscz = false;
        break;
      // 员工总览
      case 3:
        let resyg = await TbReport.GetEmployeeOverview(Object.assign({}, this[arg]));
        this.list3 =
          this[arg].skip == 0
            ? resyg.item2.map((v) => {
              return {
                ...v,
                createTime: dayjs(v.createTime).format("YYYY-MM-DD"),
              };
            })
            : this.list3.concat(
              resyg.item2.map((v) => {
                return {
                  ...v,
                  createTime: dayjs(v.createTime).format("YYYY-MM-DD"),
                };
              })
            );
        this.total = resyg.item1.total;
        this.hj3_ze = fmoney(
          (
            Number(resyg.item1.receivables) +
            Number(resyg.item1.rechargeAmount) -
            Number(resyg.item1.totalRefunded)
          ).toString(),
          2
        );
        this.hj3_sxze = fmoney(resyg.item1.actualTotal, 2);
        this.hj3_czze = fmoney(resyg.item1.rechargeAmount, 2);
        this.iscz = false;
        break;

      default:
        break;
    }
    this.currentPage++;
    this[arg].skip = (this.currentPage - 1) * s;
    this.loading = false;
    if (this[arg2].length >= this.total) {
      this.finished = true;
    }
  }
  /**获取商品列表 */
  async getList() {
    this.onRefresh();
  }
  /**重置 */
  resetSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          startDate:
            dayjs(new Date()).startOf("month").format("YYYY-MM-DD") + " " + "00:00:00",
          endDate: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          sortField: 0,
          sortType: 2,
          skip: 0,
          count: 10,
        };
        break;
      case 2:
        this.searchValue2 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          startDate:
            dayjs(new Date()).startOf("month").format("YYYY-MM-DD") + " " + "00:00:00",
          endDate: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          sortField: 0,
          sortType: 2,
          skip: 0,
          count: 10,
        };
        break;
      case 3:
        this.searchValue3 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          start:
            dayjs(new Date()).startOf("month").format("YYYY-MM-DD") + " " + "00:00:00",
          end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          nameJobNumber: "",
          skip: 0,
          count: 10,
        };
        break;
      default:
        break;
    }
    this.timeType = 1;
    this.timeActive = null;
    this.startDate = dayjs(new Date()).startOf("month").format("YYYY-MM-DD");
    this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.iscz = true;
    this.getList();
  }
  async sortFun(val) {
    if (this.curZL == 1) {
      switch (val) {
        case 1:
          this.searchValue1.sortField = 1;
          break;
        case 2:
          this.searchValue1.sortField = 2;
          break;
        case 3:
          this.searchValue1.sortField = 3;
          break;
        case 4:
          this.searchValue1.sortField = 4;
          break;
        case 5:
          this.searchValue1.sortField = 5;
          break;
        case 6:
          this.searchValue1.sortField = 6;
          break;
        case 7:
          this.searchValue1.sortField = 7;
          break;
        case 8:
          this.searchValue1.sortField = 8;
          break;
        default:
          break;
      }
      this.searchValue1.sortType = this.searchValue1.sortType == 2 ? 1 : 2;
    }
    if (this.curZL == 2) {
      switch (val) {
        case 1:
          this.searchValue2.sortField = 1;
          break;
        case 2:
          this.searchValue2.sortField = 2;
          break;
        default:
          break;
      }
      this.searchValue2.sortType = this.searchValue2.sortType == 2 ? 1 : 2;
    }
    this.iscz = false;
    await this.getList();
  }
  changeTimeStatusXL(item, index) {
    this.timeType = item.value;
    this.showStatusPopover = false;
    this.setTimeSearch();
  }
  async chooseTime(type) {
    this.timeActive = type;
    // 获取当前日期
    const today = dayjs();
    const firstDayOfWeek = dayjs().startOf("week");
    const firstDayOfMonth = dayjs().startOf("month");
    const prevMonthStart = today.subtract(1, "month").startOf("month");
    const prevMonthEnd = today.subtract(1, "month").endOf("month");
    switch (type) {
      case 1:
        this.startDate = today.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 2:
        this.startDate = firstDayOfWeek.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 3:
        this.startDate = firstDayOfMonth.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 4:
        this.startDate = prevMonthStart.format("YYYY-MM-DD");
        this.endDate = prevMonthEnd.format("YYYY-MM-DD");
        break;

      default:
        break;
    }
    await this.setTimeSearch();
  }
  async setTimeSearch() {
    switch (this.curZL) {
      case 1:
        if (this.timeType == 1) {
          this.searchValue1.startDate = this.startDate
            ? this.startDate + " 00:00:00"
            : "";
          this.searchValue1.endDate = this.endDate ? this.endDate + " 23:59:59" : "";
        } else {
          this.searchValue1.startDate = "";
          this.searchValue1.endDate = "";
        }
        break;
      case 2:
        if (this.timeType == 1) {
          this.searchValue2.startDate = this.startDate
            ? this.startDate + " 00:00:00"
            : "";
          this.searchValue2.endDate = this.endDate ? this.endDate + " 23:59:59" : "";
        } else {
          this.searchValue2.startDate = "";
          this.searchValue2.endDate = "";
        }
        break;
      case 3:
        if (this.timeType == 1) {
          this.searchValue3.start = this.startDate ? this.startDate + " 00:00:00" : "";
          this.searchValue3.end = this.endDate ? this.endDate + " 23:59:59" : "";
        } else {
          this.searchValue3.start = "";
          this.searchValue3.end = "";
        }
        break;

      default:
        break;
    }
    this.iscz = false;
    await this.getList();
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/report/components/salezl.vue